module.exports = "/_next/static/images/AggregationReverseETL@2x-370e290e992d07fc1aeb6cd0616cc9f7.png";